var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_1117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6115 4.38848C19.7601 -1.46283 10.2397 -1.46283 4.38839 4.38848C-1.4628 10.2397 -1.4628 19.7603 4.38839 25.6115C7.31405 28.5372 11.157 30 15 30C18.843 30 22.6859 28.5372 25.6117 25.6115C31.4627 19.7603 31.4627 10.2397 25.6115 4.38848ZM5.90434 24.0957C0.889017 19.0804 0.889017 10.9198 5.90434 5.90443C8.41206 3.39683 11.706 2.14291 14.9999 2.14291C18.2938 2.14291 21.5879 3.39671 24.0955 5.90443C29.1108 10.9198 29.1108 19.0804 24.0955 24.0957C19.0802 29.1109 10.9197 29.1109 5.90434 24.0957Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2037 13.9287H16.0716V6.79654C16.0716 6.20448 15.5917 5.72461 14.9996 5.72461C14.4076 5.72461 13.9277 6.20448 13.9277 6.79654V13.9287H6.79556C6.2035 13.9287 5.72363 14.4086 5.72363 15.0006C5.72363 15.5927 6.2035 16.0726 6.79556 16.0726H13.9277V23.2047C13.9277 23.7968 14.4076 24.2766 14.9996 24.2766C15.5917 24.2766 16.0716 23.7968 16.0716 23.2047V16.0726H23.2037C23.7958 16.0726 24.2757 15.5927 24.2757 15.0006C24.2757 14.4086 23.7958 13.9287 23.2037 13.9287Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_1117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.c23b127d3f5aa276ff030b2da0765200.svg";
export { ForwardRef as ReactComponent };